import { render, staticRenderFns } from "./ItemDescriptions.vue?vue&type=template&id=445d1a28&"
import script from "./ItemDescriptions.vue?vue&type=script&lang=js&"
export * from "./ItemDescriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports